<template>
    <div class="workNumConfig">
        <!-- 标题 -->
        <Title-Box :top-title="topTitle"></Title-Box>
        <el-form ref="form" :rules="rules" :model="postConfigForm" label-width="110px" class="formStyle">

            <el-row style="padding-top: 10px;">
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="所属区域" prop="AREA_NAME" class="areaFormItem">
                        <span @click="showAreaTree = true">{{postConfigForm.AREA_NAME}}</span>
                        <div class="areaBox boxs" v-if="showAreaTree" @click="showAreaTree = false">
                            <el-tree 
                                :data="areaTreeData" 
                                :props="areaTreeProps" 
                                @node-click="handleAreaTreeClick"
                                highlight-current
                            >
                            </el-tree>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="上级会员" prop="dev_member" v-if="dialogTitle == 'add'">
                        <el-select v-model="postConfigForm.dev_member" placeholder="请选择上级组织会员" filterable clearable>
                            <el-option v-for="item in higherLevelMemberOptions" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上级会员" prop="dev_member" v-if="dialogTitle == 'edit'">
                        <el-select v-model="postConfigForm.dev_member" placeholder="请选择上级组织会员" filterable clearable disabled>
                            <el-option v-for="item in higherLevelMemberOptions" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="会员名称" prop="name">
                        <el-input
                                v-model="postConfigForm.name"
                                placeholder="请输入会员名称"
                                maxlength="32" clearable
                                @input="e => postConfigForm.name = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="会员账号" prop="code">
                        <el-input
                                v-model="postConfigForm.code"
                                placeholder="请输入会员账号"
                                maxlength="32" clearable
                                @input="e => postConfigForm.code = validForbid(e)"
                                v-if="dialogTitle == 'add'"
                        >
                        </el-input>
                        <el-input
                                v-model="postConfigForm.code"
                                placeholder="请输入会员账号"
                                maxlength="32" clearable
                                @input="e => postConfigForm.code = validForbid(e)"
                                v-if="dialogTitle == 'edit'"
                                disabled
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="会员类型" prop="type" v-if="dialogTitle == 'add'">
                        <el-select v-model="postConfigForm.type" placeholder="请选择会员类型" filterable clearable>
                            <el-option v-for="item in memberTypeOptions" :key="item.id" :label="item.memberType" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="会员类型" prop="type" v-if="dialogTitle == 'edit'">
                        <el-select v-model="postConfigForm.type" placeholder="请选择会员类型" filterable clearable disabled>
                            <el-option v-for="item in memberTypeOptions" :key="item.id" :label="item.memberType" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>


            <!-- 其他信息 -->
            <p class="otherTitle">其他信息</p>
            <el-row style="padding-top: 20px;">
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="联系人" prop="contact_people">
                        <el-input
                                v-model="postConfigForm.contact_people"
                                placeholder="请输入联系人"
                                maxlength="10" clearable
                                @input="e => postConfigForm.contact_people = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="联系电话" prop="mobile">
                        <el-input
                                v-model="postConfigForm.mobile"
                                placeholder="请输入联系电话"
                                maxlength="11" clearable
                                @input="e => postConfigForm.mobile = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="联系邮箱" prop="email">
                        <el-input
                                v-model="postConfigForm.email"
                                placeholder="请输入联系邮箱"
                                maxlength="30" clearable
                                @input="e => postConfigForm.email = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="联系地址" prop="address">
                        <el-input
                                v-model="postConfigForm.address"
                                placeholder="请输入联系地址"
                                maxlength="40" clearable
                                @input="e => postConfigForm.address = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row style="padding-top: 20px; margin-top: 20px;">
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="交费易账号" prop="PAYEASY_ACCOUNT">
                        <el-input
                                v-model="postConfigForm.PAYEASY_ACCOUNT"
                                placeholder="请输入交费易账号"
                                maxlength="30" clearable
                                @input="e => postConfigForm.PAYEASY_ACCOUNT = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row style="padding-top: 20px; margin-top: 20px;">
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="受理点" prop="OFFICE_ID">
                        <el-input
                                v-model="postConfigForm.OFFICE_ID"
                                placeholder="请输入受理点"
                                maxlength="30" clearable
                                @input="e => postConfigForm.OFFICE_ID = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="受理工号" prop="OPERATOR_ID">
                        <el-input
                                v-model="postConfigForm.OPERATOR_ID"
                                placeholder="请输入受理工号"
                                maxlength="30" clearable
                                @input="e => postConfigForm.OPERATOR_ID = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="受理员名称" prop="OPERATOR_NAME">
                        <el-input
                                v-model="postConfigForm.OPERATOR_NAME"
                                placeholder="请输入受理员名称"
                                maxlength="30" clearable
                                @input="e => postConfigForm.OPERATOR_NAME = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <!-- 渠道类型等 -->
            <el-row :gutter="65" style="padding-top: 20px; margin-top: 20px;">
                <!-- 渠道类型、省份渠道编码、发展人三级编码 -->
                <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item label="渠道类型" prop="CHAN_TYPE">
                        <el-input
                                v-model="postConfigForm.CHAN_TYPE"
                                placeholder="请输入渠道类型"
                                maxlength="30" clearable
                                @input="e => postConfigForm.CHAN_TYPE = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item label="省份渠道编码" prop="SF_CHAN_CODE">
                        <el-input
                                v-model="postConfigForm.SF_CHAN_CODE"
                                placeholder="请输入省份渠道编码"
                                maxlength="30" clearable
                                @input="e => postConfigForm.SF_CHAN_CODE = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item label="发展人三级编码" prop="DEVELOP_CODE_3">
                        <el-input
                                v-model="postConfigForm.DEVELOP_CODE_3"
                                placeholder="请输入发展人三级编码"
                                maxlength="30" clearable
                                @input="e => postConfigForm.DEVELOP_CODE_3 = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <!-- 总部渠道编码、省份发展人编码、发展人四级编码 -->
                <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item label="总部渠道编码" prop="CHAN_CODE">
                        <el-input
                                v-model="postConfigForm.CHAN_CODE"
                                placeholder="请输入总部渠道编码"
                                maxlength="30" clearable
                                @input="e => postConfigForm.CHAN_CODE = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item label="省份发展人编码" prop="SF_DEVELOP_CODE">
                        <el-input
                                v-model="postConfigForm.SF_DEVELOP_CODE"
                                placeholder="请输入省份发展人编码"
                                maxlength="30" clearable
                                @input="e => postConfigForm.SF_DEVELOP_CODE = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item label="发展人四级编码" prop="DEVELOP_CODE_4">
                        <el-input
                                v-model="postConfigForm.DEVELOP_CODE_4"
                                placeholder="请输入发展人四级编码"
                                maxlength="30" clearable
                                @input="e => postConfigForm.DEVELOP_CODE_4 = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <!-- 总部发展人编码、省份发展人名称 -->
                <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item label="总部发展人编码" prop="DEVELOP_CODE">
                        <el-input
                                v-model="postConfigForm.DEVELOP_CODE"
                                placeholder="请输入总部发展人编码"
                                maxlength="30" clearable
                                @input="e => postConfigForm.DEVELOP_CODE = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item label="省份发展人名称" prop="SF_DEVELOP_NAME">
                        <el-input
                                v-model="postConfigForm.SF_DEVELOP_NAME"
                                placeholder="请输入省份发展人名称"
                                maxlength="30" clearable
                                @input="e => postConfigForm.SF_DEVELOP_NAME = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row style="padding-top: 20px; margin-top: 20px;">
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="银行账号" prop="BANK_ACCOUNT">
                        <el-input
                                v-model="postConfigForm.BANK_ACCOUNT"
                                placeholder="请输入银行账号"
                                maxlength="30" clearable
                                @input="e => postConfigForm.BANK_ACCOUNT = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="银行名称" prop="BANK_NAME">
                        <el-input
                                v-model="postConfigForm.BANK_NAME"
                                placeholder="请输入银行名称"
                                maxlength="30" clearable
                                @input="e => postConfigForm.BANK_NAME = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="户名" prop="ACCOUNT_NAME">
                        <el-input
                                v-model="postConfigForm.ACCOUNT_NAME"
                                placeholder="请输入户名"
                                maxlength="30" clearable
                                @input="e => postConfigForm.ACCOUNT_NAME = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row style="padding-top: 20px; margin-top: 20px;">
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="推荐人" prop="REFERRER">
                        <el-select v-model="postConfigForm.REFERRER" placeholder="请选择推荐人" filterable clearable>
                            <el-option v-for="item in recommenderOptions" :key="item.ID" :label="item.NAME" :value="item.ID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="圈存帐号" prop="qc_account">
                        <el-input
                                v-model="postConfigForm.qc_account"
                                placeholder="请输入圈存帐号"
                                maxlength="30" clearable
                                @input="e => postConfigForm.qc_account = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="12" :sm="12" :lg="9">
                    <el-form-item label="圈存密码" prop="qc_password">
                        <el-input
                                v-model="postConfigForm.qc_password"
                                placeholder="请输入圈存密码"
                                maxlength="30" 
                                clearable
                                type="password"
                                @input="e => postConfigForm.qc_password = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row style="margin-top: 6px; padding-top: 20px;">
                <el-col :span="16">
                    <el-form-item label="备注" prop="note">
                        <el-input
                                v-model="postConfigForm.note"
                                placeholder="请输入备注"
                                maxlength="180"
                                clearable
                                type="textarea"
                                :rows="3"
                                @input="e => postConfigForm.note = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <p class="tips">填写说明：会员注册/导入默认密码:888888</p>

        </el-form>

        <div class="flex-row jus-c btnBox">
            <button @click="beforeClose" class="butStyle cancelBtn">取 消</button>
            <button @click="validateForm" class="butStyle refuseOBtn">确 定</button>
        </div>
    </div>
</template>

<script>
import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
import {
    addMemberReq, //添加会员
    editMemberReq, //编辑会员
    checkMemberReq, //会员校验 校验是否有相同的用户存在 
    getMemberDetailReq, //获取指定会员信息(编辑弹窗回显)
    getAreaTreeDataReq, //所属区域（区域树数据）
    getHigherLevelMemberMap, //上级会员下拉框
    getRecommenderMap, //获取推荐人列表
} from '@/api/System/memberManage.js';
import {
    getCurrentUserInfoAPI, //获取当前登录会员信息
} from '@/api/common.js';

// 表单Form的数据
const defaultPostConfigForm = {
    AREA_NAME: null, //所属区域
    area_id: null, //所属区域
    dev_member: null, //上级会员
    name: null, //会员名称
    code: null, //会员账号
    type: null, //会员类型

    contact_people: null, //联系人
    mobile: null, //联系电话
    email: null, //联系邮箱
    address: null, //联系地址

    PAYEASY_ACCOUNT: null, //交费易账号

    OFFICE_ID: null, //受理点
    OPERATOR_ID: null, //受理工号
    OPERATOR_NAME: null, //受理员名称

    CHAN_TYPE: null, //渠道类型
    SF_CHAN_CODE: null, //省份渠道编码
    DEVELOP_CODE_3: null, //发展人三级编码
    CHAN_CODE: null, //总部渠道编码
    SF_DEVELOP_CODE: null, //省份发展人编码
    DEVELOP_CODE_4: null, //发展人四级编码
    DEVELOP_CODE: null, //总部发展人编码
    SF_DEVELOP_NAME: null, //省份发展人名称

    BANK_ACCOUNT: null, //银行账号
    BANK_NAME: null, //银行名称
    ACCOUNT_NAME: null, //户名
    
    REFERRER: null, //推荐人
    qc_account: null, //圈存帐号
    qc_password: null, //圈存密码


    note: null, //备注

    memberId: null, //会员ID
    t: null, // 当前时间戳 
}

export default {
    name: "WorkNumConfigIndex",
    data() {
        // 会员账号格式校验(只能输入数字和英文字母)
        const validateCode = (rule, value, callback) => {
            if (!value) {
                // 会员账号不能为空
                return callback(new Error('请输入会员账号'))
            }
            // 会员账号不为空时校验格式
            const regex = /^[0-9A-Za-z]+$/
            if (regex.test(value)) {
                callback()
            } else {
                return callback(new Error('请输入数字或英文字母'))
            }
        }
        // 联系电话格式校验（固话手机号都可）
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                // 手机可为空
                return callback()
            } else {
                // 手机不为空时校验格式
                // const phoneReg = /^[1][3,4,5,6,7,8][0-9]{9}$/
                const phoneReg = /^[1][3,4,5,6,7,8][0-9]{9}$|^0\d{2,3}-?\d{7,8}$/
                if (phoneReg.test(value)) {
                    callback()
                } else {
                    return callback(new Error('请输入正确的联系电话格式（手机或固话）'))
                }
            }
        }

        // 邮箱格式校验
        const validateEmail = (rule, value, callback) => {
            if (!value) {
                // 邮箱可为空
                return callback()
            } else {
                // 邮箱不为空时校验格式
                const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
                if (mailReg.test(value)) {
                    callback()
                } else {
                    return callback(new Error('请输入正确的邮箱格式'))
                }
            }
        }
        return {
            //标题
            topTitle: {
                title: '会员管理',
                subTit: '配置工号'
            },

            // 表单名称add、edit
            dialogTitle: '',
            // 表单Form的数据
            postConfigForm: Object.assign({}, defaultPostConfigForm),
            // 会员类型
            memberTypeOptions: [
                { id: '0', memberType:'代理商会员' },
                { id: '1', memberType:'网点会员' },
                { id: '2', memberType:'微店会员' },
                { id: '3', memberType:'超级会员' },
                { id: '4', memberType:'平台商/运营商会员' },
                { id: '5', memberType:'顾客会员' }
            ],
            // 所属区域树窗口是否显示
            showAreaTree: false,
            // 区域树数据
            areaTreeData: [],
            // 区域树数据格式
            areaTreeProps: {
                children: 'children',
                label: 'text',
                labelId: 'id',
            },
            // 上级会员
            higherLevelMemberOptions: [],
            // 推荐人
            recommenderOptions: [],
            
            // 表单Form校验规则
            rules: {
                AREA_NAME: [{required: true, message: '请选择区域', trigger: 'blur'}],
                dev_member: [{required: true, message: '请选择上级组织会员', trigger: 'blur'}],
                name: [{required: true, message: '请输入会员名称', trigger: 'blur'}],
                code: [{required: true, validator: validateCode, trigger: 'blur'}],
                type: [{required: true, message: '请选择会员类型', trigger: 'blur'}],
                mobile: [{validator: validatePhone, trigger: 'blur'}],
                email: [{validator: validateEmail, trigger: 'blur'}]
            },
        }
    },
    components: {
        TitleBox
    },
    created () {
        this.dialogTitle = this.$route.query.dialogTitle;
        if(this.dialogTitle === 'add') {
            this.initAddFormDataFun()
            // 获取弹窗默认区域（默认区域数据的第一个）
            this.getDefaultAreaTreeData()
        } else if(this.dialogTitle === 'edit') {
            this.initEditFormDataFun()
        }

        // 获取当前登录会员信息
        this.getCurrentUserInfoAPI();
        // 获取区域树数据
        this.getAreaTreeData()
        // 上级会员下拉框
        this.initHigherLevelMemberOptions()
        // 获取推荐人列表
        this.initRecommenderOptions()
    },
    methods: {
        // 获取添加会员页面携带过来的数据
        initAddFormDataFun() {
            // this.postConfigForm.AREA_NAME = this.$route.query.AREA_NAME
            // this.postConfigForm.area_id = this.$route.query.area_id
            // this.postConfigForm.dev_member = this.$route.query.dev_member
            // this.postConfigForm.name = this.$route.query.name
            // this.postConfigForm.code = this.$route.query.code
            // this.postConfigForm.type = this.$route.query.type
            // this.postConfigForm.memberId = this.$route.query.memberId

            this.postConfigForm = this.$route.query
        },
        // 获取编辑会员页面携带过来的数据
        initEditFormDataFun() {
            this.postConfigForm.AREA_NAME = this.$route.query.AREA_NAME
            this.postConfigForm.area_id = this.$route.query.area_id
            // 编辑会员时，不传“上级会员”
            // dev_member先用来回显，等提交编辑时再置为空
            this.postConfigForm.dev_member = this.$route.query.dev_member

            // 注意：编辑会员的 “会员名称是name2”，“会员编码是code2”
            // name和code先用来回显，等提交编辑时再置为空
            this.postConfigForm.name = this.$route.query.name
            this.postConfigForm.code = this.$route.query.code
            this.postConfigForm.name2 = this.$route.query.name
            this.postConfigForm.code2 = this.$route.query.code
            // 编辑会员时，不传“会员类型”
            // type先用来回显，等提交编辑时再置为空
            this.postConfigForm.type = this.$route.query.type
            this.postConfigForm.note = this.$route.query.note
            this.postConfigForm.memberId = this.$route.query.memberId

            // console.log('this.$route.query', this.$route.query)
            
            // 通过当前会员ID请求更多的数据
            this.getMemberDetail(this.postConfigForm.memberId)
        },

        
        // 获取弹窗默认区域（默认区域数据的第一个）
        getDefaultAreaTreeData () {
            getAreaTreeDataReq().then(resp => {
                this.postConfigForm.AREA_NAME = resp[0].text
                this.postConfigForm.area_id = resp[0].id
            }).catch(err => {
                console.log(err)
            })
        },
        // 获取弹窗区域树数据
        getAreaTreeData () {
            getAreaTreeDataReq().then(resp => {
                this.areaTreeData = resp
            }).catch(err => {
                console.log(err)
            })
        },
        // 获取当前登录会员信息
        getCurrentUserInfoAPI () {
            getCurrentUserInfoAPI().then(resp => {
                const res= resp.data;
                console.log('res:', res);
                //  '会员类型，0 代理商会员，1 网点会员，2 微店会员，3  超级会员，4 平台商/运营商会员，5 顾客会员',
                const memberType = res.memberType;
                if(memberType == '3'){
                    this.memberTypeOptions = [
                        {id: '0', memberType: '代理商会员'},
                        {id: '1', memberType: '网点会员'},
                        {id: '2', memberType: '微店会员'},
                        // {id: '3', memberType: '超级会员'},
                        {id: '4', memberType: '平台商/运营商会员'},
                        {id: '5', memberType: '顾客会员'}
                    ];
                }
                if(memberType == '4'){
                    this.memberTypeOptions = [
                        {id: '0', memberType: '代理商会员'},
                    ];
                }
                if(memberType == '0'){
                    this.memberTypeOptions = [
                        {id: '1', memberType: '网点会员'},
                    ];
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 区域树点击
        handleAreaTreeClick(data) {
            // console.log('AreaTreedata', data)
            this.postConfigForm.AREA_NAME = data.text
            this.postConfigForm.area_id = data.id
            this.showAreaTree = false
        },
        // 上级会员下拉框
        initHigherLevelMemberOptions () {
            getHigherLevelMemberMap().then(resp => {
                this.higherLevelMemberOptions = resp.body.rows
            }).catch(err => {
                console.log(err)
            })
        },
        // 获取推荐人列表
        initRecommenderOptions () {
            getRecommenderMap().then(resp => {
                this.recommenderOptions = resp.body.rows
            }).catch(err => {
                console.log(err)
            })
        },
        // 获取指定会员信息(编辑弹窗回显)
        getMemberDetail (id) {
            // console.log('getMemberDetail-id', id)
            const params = {
                memberId: id
            }
            getMemberDetailReq(params).then(resp => {
                if (resp.header && resp.header.code != 0) {
                    this.$message.error(resp.header.message)
                    return
                }
                const memberDetail = resp.body.rows[0]

                this.postConfigForm.contact_people = memberDetail.CONTACT_PEOPLE
                this.postConfigForm.mobile = memberDetail.MOBILE
                this.postConfigForm.email = memberDetail.EMAIL
                this.postConfigForm.address = memberDetail.ADDRESS
                
                this.postConfigForm.PAYEASY_ACCOUNT = memberDetail.PAYEASY_ACCOUNT

                this.postConfigForm.OFFICE_ID = memberDetail.OFFICE_ID
                this.postConfigForm.OPERATOR_ID = memberDetail.OPERATOR_ID
                this.postConfigForm.OPERATOR_NAME = memberDetail.OPERATOR_NAME

                this.postConfigForm.CHAN_TYPE = memberDetail.CHAN_TYPE
                this.postConfigForm.SF_CHAN_CODE = memberDetail.SF_CHAN_CODE
                this.postConfigForm.DEVELOP_CODE_3 = memberDetail.DEVELOP_CODE_3
                this.postConfigForm.CHAN_CODE = memberDetail.CHAN_CODE
                this.postConfigForm.SF_DEVELOP_CODE = memberDetail.SF_DEVELOP_CODE
                this.postConfigForm.DEVELOP_CODE_4 = memberDetail.DEVELOP_CODE_4
                this.postConfigForm.DEVELOP_CODE = memberDetail.DEVELOP_CODE
                this.postConfigForm.SF_DEVELOP_NAME = memberDetail.SF_DEVELOP_NAME
                
                this.postConfigForm.BANK_ACCOUNT = memberDetail.BANK_ACCOUNT
                this.postConfigForm.BANK_NAME = memberDetail.BANK_NAME
                this.postConfigForm.ACCOUNT_NAME = memberDetail.ACCOUNT_NAME
                
                this.postConfigForm.REFERRER = memberDetail.REFERRER
                this.postConfigForm.qc_account = memberDetail.QC_ACCOUNT

                if(memberDetail.QC_ACCOUNT != '') {
                    this.postConfigForm.qc_password = 'zsQCMM'
                    // console.log('有圈存账号', this.postConfigForm.qc_password)
                }

                // 这些是要传的参数（虽然页面没有）
                this.postConfigForm.chnnpeoname = memberDetail.CHNNPEONAME
                this.postConfigForm.REFERRER_MEMBER_NAME = memberDetail.REFERRER_MEMBER_NAME
                this.postConfigForm.status2 = memberDetail.STATUS
                this.postConfigForm.statusname = memberDetail.STATUSNAME

            }).catch(err => {
                console.log(err)
            })
        },


        // 弹窗关闭前
        beforeClose() {
            this.resetData()
        },
        // 跳转到会员管理业
        goMemberManage() {
            this.resetData()
        },
        
        // 重置表单
        resetData() {
            this.$router.push({
                path: '/system/memberManage',
                query: {}
            })
            this.$nextTick(() => {
                this.$refs['form'].clearValidate()
            })
            this.postConfigForm = Object.assign({}, defaultPostConfigForm)
            
        },

        // 验证表单-点击弹窗的“确定”按钮
        validateForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitForm()
                } else {
                    // this.dialogFormVisible = true
                }
            })
        },

        submitForm() {
            if (this.dialogTitle === 'add') {

                this.addMember();
                
            } else if (this.dialogTitle === 'edit') {

                this.editMember();
            }
        },

        // 添加会员
        addMember () {
            // 会员校验 校验是否有相同的用户存在
            const checkParams = {
                code: this.postConfigForm.code
            }
            checkMemberReq(checkParams).then(resp => {
                if (resp.header && resp.header.code != 0) {
                    this.$message.error(resp.header.message)
                    return
                }
                const memberCount = resp.body.rows[0].count
                // memberCount = parseInt(memberCount)
                if (memberCount > 0) {
                    this.$message.error('已存在相同的会员账号，请重新输入！')
                    return
                }

                // 没有相同的会员账号，可继续下一步“新增会员”
                const timeStamp = new Date().getTime();
                this.postConfigForm.t = timeStamp.toString();
                const addParams = this.postConfigForm;
                addParams.password = '888888'; // 确认密码
                addParams.confirm_password = '888888'; // 再次确认密码
                addMemberReq(addParams).then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    this.$message.success('添加会员成功')
                    this.goMemberManage()
                }).catch(err => {
                    console.log(err)
                })

            }).catch(err => {
                console.log(err)
            })
        },

        // 编辑会员
        editMember () {
            // const timeStamp = new Date().getTime();
            // this.postConfigForm.t = timeStamp.toString();

            if(this.postConfigForm.qc_password == 'zsQCMM') {
                this.postConfigForm.qc_password = null
            }

            // 编辑会员时，不传“上级会员”，等提交编辑时再置为空
            this.postConfigForm.dev_member = null
            // 注意：编辑会员的 “会员名称是name2”，“会员编码是code2”，name和code先用来回显，等提交编辑时再置为空
            this.postConfigForm.name2 = this.postConfigForm.name
            this.postConfigForm.name = null
            this.postConfigForm.code2 = this.postConfigForm.code
            this.postConfigForm.code = null
            // 编辑会员时，不传“会员类型”，type先用来回显，等提交编辑时再置为空
            this.postConfigForm.type = null

            const editParams = this.postConfigForm;

            editMemberReq(editParams).then(resp => {
                if (resp.header && resp.header.code != 0) {
                    this.$message.error(resp.header.message)
                    return
                }
                this.$message.success('编辑会员成功')
                this.goMemberManage()
            }).catch(err => {
                console.log(err)
            })
        },

    },
    
    
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>


.workNumConfig {
    min-width: 800px;
}

.workNumConfig .formStyle {
    background: #F8F8F8;
}
.workNumConfig .el-row {
    background: #ffffff;
}

.workNumConfig .otherTitle {
    height: 20px;
    line-height: 20px;
    margin-top: 6px;
    padding-top: 14px;
    padding-left: 12px;
    background: #ffffff;
    color: #2B2727;
    font-size: 15px;
    font-weight: bold;
}

// 弹窗-区域
.workNumConfig .areaFormItem {
    position: relative;
}
.workNumConfig .areaFormItem span {
    color: #FA6241;
}
// 区域树盒子
.workNumConfig .areaFormItem .areaBox {
    width: 200px;
    height: 250px;
    // height: 150px;
    // max-height: 250px;
    // margin-left: 20px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    overflow-y: auto;
    overflow-x: auto;

    position: absolute;
    top: 33px;
    left: 0px;
    z-index: 2999;
}

.tips {
    width: 100%;
    height: 16px;
    line-height: 16px;
    padding: 0 0 12px 56px;
    font-size: 12px;
    color: #7F7F7F;
    background: #ffffff;
}


.btnBox {
    width: 100%;
    margin-top: 24px;
}

// 弹窗按钮-取消按钮
.cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
}

// 弹窗按钮-橙色按钮
.refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;
    &:hover {
      background-color: rgb(247, 143, 120);
    }
}


</style>
